import React from "react";

function doneIcon() {
  return (
    <svg
      width="129"
      height="129"
      viewBox="0 0 129 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="9.16699"
        y="9.16699"
        width="110"
        height="110"
        rx="55"
        fill="#D1FADF"
      />
      <rect
        x="9.16699"
        y="9.16699"
        width="110"
        height="110"
        rx="55"
        stroke="#ECFDF3"
        strokeWidth="18.3333"
      />
      <path
        d="M53.8542 64.1667L60.7292 71.0417L74.4792 57.2917M87.0833 64.1667C87.0833 76.8232 76.8232 87.0833 64.1667 87.0833C51.5101 87.0833 41.25 76.8232 41.25 64.1667C41.25 51.5101 51.5101 41.25 64.1667 41.25C76.8232 41.25 87.0833 51.5101 87.0833 64.1667Z"
        stroke="#039855"
        strokeWidth="4.58333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default doneIcon;
